<template>
    <div class="navContent s_bf2">
      <div class="navItem" v-for="(v,k) in data.data" :key="k">
        <img  style="object-fit:cover" :src="v.imgUrl?v.imgUrl.indexOf('http')!=-1?v.imgUrl:info.picdomain+v.imgUrl:require('@/assets/images/normal.png')"  alt="">
        <p>{{v.name}}</p>
      </div>
    </div>
</template>
<script>
import config from '@/config'

export default {
    props: { data: Object },
    setup(){
      return{
        assetsOss:config.oss[process.env.VUE_APP_type]
      }
    }
}
</script>
<style lang="less" scoped>
.navContent {
  display: flex;
  flex-wrap: wrap;
  padding:10px;
  width: 100%;
  .navItem{
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    color: #8e8e8e;
    img{
      width: 30px;
      height: 30px;
    }
  }
}
</style>